import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Navbar from "../components/navbar";
import MobileApp from "../components/mobile-app";
import Footer from "../components/footer";
import Switcher from "../components/switcher";

import { newProduct, salesData } from "../data/data";
import {FiHeart, FiEye, FiBookmark} from '../assets/icons/vander'
import ScrollToTop from "../components/scroll-to-top";
import { useGetProductsOnSaleQuery } from "../redux/services/products";
import { createClient } from "../utils/supbase/client";
import { useAddItemtoCartMutation } from "../redux/services/cart";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useAddItemtoWishlistMutation } from "../redux/services/wishlist";


export default function Sale(){
  const supabase = createClient();
  const navigate = useNavigate();
  const [productsOnSale, setProductsOnSale] = useState([]);
  const [addProductToCart, { data }] = useAddItemtoCartMutation();
  const user = useSelector((state) => state.auth.user);
  const [wishlist, setWishlist] = useState([]);
  const [addProductToWishlist] = useAddItemtoWishlistMutation();


    useEffect(() => {
        const fetchData = async () => {
          const { data, error } = await supabase
            .from("products")
            .select("*")
            .not("sale_price", "is", null)
            .gt("sale_price", 0); 
      
          if (error) {
            console.error("Error fetching data:", error);
          } else {
            setProductsOnSale(data);
            console.log("Fetched data:", data);
          }
        };
      
        fetchData();
      }, []);

      function isUserIdPresent(records) {
        for (let record of records) {
            if (record.user_id === user.id || wishlist.includes(record.product_id)) {
                return true;
            }
        }
        return false;
    }

      useEffect(() => {
        if (productsOnSale?.length) {
            productsOnSale?.forEach(element => {
            element.wishlist?.forEach(item => {
              if (isUserIdPresent(element.wishlist) && !wishlist.includes(item.product_id)) {
                setWishlist(prev => [...prev, item.product_id]);
              }
            });
          });
        }
      }, [productsOnSale, wishlist]);

      const handleAddToCart = (details) => {
        if (!user?.id) {
            toast.warning("Please login to add to cart");
            return;
        }
        addProductToCart({
          quantity: 1,
          product_id: details.id,
          user_id: user.id,
        });
        navigate("/shop-cart");
    }

    const handleHeartClick = async (e, details) => {
        e.stopPropagation();
        if (!user?.id) {
            toast.warning("Please login to add to wishlist");
            return;
        }
        if (isUserIdPresent(details.wishlist)) {
            toast.warning("Product already added to wishlist");
        } else {
            await addProductToWishlist({
                product_id: details.id,
                user_id: user.id,
            })
            setWishlist((prev)=> [...prev, details.id])
            toast.success("Product added to Wishlist !");
        }
    }
    
    return(
        <>
        <Navbar navClass="defaultscroll is-sticky tagline-height" navlight={true}/>

        <section className="relative table w-full items-center pt-36 pb-52 bg-orange-600 bg-[url('../../assets/images/hero/bg-shape.png')] bg-center bg-no-repeat bg-cover">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-10">
                    <h3 className="md:text-7xl text-5xl md:leading-normal leading-normal tracking-wide font-bold uppercase text-white">Sale Outlet</h3>
                    <div className="mt-6">
                        <Link to="" className="py-2 px-5 inline-block font-semibold tracking-wide align-middle text-center bg-white text-orange-500 rounded-md">Offer Grab Now</Link>
                    </div>
                </div>
            </div>
        </section>

        <section className="relative md:py-24 py-16">
            {/* <div className="container relative">
                <div className="grid grid-cols-1 justify-center">
                    <div className="relative z-2 duration-500 sm:-mt-[200px] -mt-[140px] m-0">
                        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-6">
                            {salesData.map((item,index)=>{
                                return(
                                    <div className="relative overflow-hidden rounded-md text-center shadow-md" key={index}>
                                        <div className="p-6 bg-orange-500">
                                            <span className="bg-white text-orange-500 font-bold px-2.5 py-0.5 rounded-full h-5">{item.tag}</span>

                                            <h5 className="text-white font-medium mt-2">{item.title}</h5>

                                            <p className="text-white/70 mt-2">Use this below code <br/>{item.desc}</p>
                                        </div>

                                        <div className="p-6 bg-white dark:bg-slate-900">
                                            <p className="text-sm font-medium uppercase">Use Code</p>
                                            <h5 className="text-xl font-semibold uppercase mt-1">{item.code}</h5>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="container relative md:mt-24 mt-16">
                <div className="grid grid-cols-1 justify-center text-center mb-6">
                    <h5 className="font-semibold text-3xl leading-normal mb-4">Top Offers</h5>
                    <p className="text-slate-400 max-w-xl mx-auto">Shop the latest products from the most popular collections</p>
                </div>

                <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 pt-6 gap-6">
                    {productsOnSale?.map((item, index)=>{
                        return(
                            <div className="group" key={index}>
                                <div className="relative overflow-hidden shadow dark:shadow-gray-800 group-hover:shadow-lg group-hover:dark:shadow-gray-800 rounded-md duration-500">
                                    <img src={item?.image_urls[0]} className="group-hover:scale-110 duration-500" alt=""/>
            
                                    <button
                                        className="absolute -bottom-20 group-hover:bottom-3 start-3 end-3 py-2 px-5 font-semibold tracking-wide align-middle duration-500 text-base text-center bg-slate-900 text-white w-full rounded-md"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleAddToCart(item);
                                        }}
                                    >
                                        Add to Cart
                                    </button>
            
                                    <ul className="list-none absolute top-[10px] end-4 opacity-0 group-hover:opacity-100 duration-500 space-y-1">
                                        <li role="button" onClick={(e)=> handleHeartClick(e,item) } ><Link to="#" className="size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"><FiHeart className="size-4"></FiHeart></Link></li>
                                        <li className="mt-1 ms-0"><Link to="/shop-item-detail" className="size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"><FiEye className="size-4"></FiEye></Link></li>
                                        {/* <li className="mt-1 ms-0"><Link to="#" className="size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"><FiBookmark className="size-4"></FiBookmark></Link></li> */}
                                    </ul>

                                    {/* <ul className="list-none absolute top-[10px] start-4">
                                        {item.offer === true && (

                                            <li><Link to="#" className="bg-orange-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5">{item.tag}</Link></li>
                                        )}
                                        {item.tag === 'New' && (
                                            <li><Link to="#" className="bg-red-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5">{item.tag}</Link></li>
                                        )}
                                        {item.tag === 'Featured' && (
                                            <li><Link to="#" className="bg-emerald-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5">{item.tag}</Link></li>
                                        )}
                                    </ul> */}
                                    <ul className="list-none absolute top-[10px] start-4">
                                        {item?.sale_price && (

                                            <li><Link to="#" className="bg-orange-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5">{item?.sale_price}% OFF</Link></li>
                                        )}
                                    </ul>
                                </div>

                                <div className="mt-4">
                                    <Link to={`/product-detail-three/${item.id}`} className="hover:text-orange-500 text-lg font-medium">{item?.title}</Link>
                                    <div className="flex justify-between items-center mt-1">
                                        <p>${ Math.floor(item?.price * (1 - item?.sale_price / 100))}  <del className="text-slate-400">${item?.price}</del></p>
                                        <ul className="font-medium text-amber-400 list-none">
                                            <li className="inline"><i className="mdi mdi-star"></i></li>
                                            <li className="inline"><i className="mdi mdi-star"></i></li>
                                            <li className="inline"><i className="mdi mdi-star"></i></li>
                                            <li className="inline"><i className="mdi mdi-star"></i></li>
                                            <li className="inline"><i className="mdi mdi-star"></i></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            {/* <MobileApp/> */}
        </section>
        <Footer/>
        {/* <Switcher/> */}
        <ScrollToTop/>
        </>
    )
}